import { Component, OnInit, DestroyRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../../../_services/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-verify-email',
  imports: [CommonModule],
  templateUrl: './verify-email.component.html',
  styleUrl: './verify-email.component.css'
})
export class VerifyEmailComponent implements OnInit {
  verificationStatus: 'verifying' | 'success' | 'error' = 'verifying';
  errorMessage: string = '';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const token = params['token'];
      if (token) {
        this.authService.verifyEmail(token)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe({
            next: (res: any) => {
              this.verificationStatus = 'success';
              const passwordToken = res.passwordToken;
              setTimeout(() => {
                this.router.navigate(['/auth/email-confirmed'], { queryParams: { token: passwordToken } });
              }, 2000);
            },
            error: (err) => {
              this.verificationStatus = 'error';
              this.errorMessage = err.error?.message || 'Invalid or expired verification token. Please try again.';
            }
          });
      } else {
        this.verificationStatus = 'error';
        this.errorMessage = 'Verification token not found in the URL.';
      }
    });
  }
}
